import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ConfigProvider } from './contexts/ConfigContext'
import { syncCnpjClientes } from '@/scripts/syncCnpjClientes'

// Expor utilitários no escopo global apenas em desenvolvimento
if (import.meta.env.DEV) {
  (window as any).syncCnpjClientes = syncCnpjClientes;
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
